import httpClient from '../httpClient';

const get = async (id) => {
  return await httpClient.get(`/resumes/${id}/`);
};

export { get };
